import React from "react"
import {Spinner, Text} from "atmosfair-ui";
import "./styles.css"
import {SMALL_SPINNER_SIZE} from "../../../utils/common";

interface SectionTitleProps {
    isLoading?: boolean,
    title: string,
    subTitle?: string,
}

const SectionTitle = ({
                          isLoading,
                          title,
                          subTitle
                      }: SectionTitleProps) => <div className={"section-title-container"}>
    <div className={"section-title-spinner-title-wrapper"}>

        {isLoading && <Spinner size={SMALL_SPINNER_SIZE} fullPage={false}/>}
        <Text
            style={{width: "100%"}}
            variant={"headlineMedium"}>
            {title}
        </Text>
    </div>
    {subTitle && <Text variant={"headlineSmall"}>{subTitle}</Text>}
</div>

export default SectionTitle